import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { Daterangepicker } from 'ng2-daterangepicker';
import { ComponentModule } from './../../../../components/component.module';
import { LayoutModule } from './../../../../layouts/layout.module';
import { AccWidInvLisItemCouponComponent } from './acc-wid-invoces-list/acc-wid-inv-lis-item-coupon/acc-wid-inv-lis-item-coupon.component';
import { AccWidInvLisItemComponent } from './acc-wid-invoces-list/acc-wid-inv-lis-item/acc-wid-inv-lis-item.component';
import { AccWidInvocesListComponent } from './acc-wid-invoces-list/acc-wid-invoces-list.component';
import { AccWidMainListComponent } from './acc-wid-main-list/acc-wid-main-list.component';
import { AccWidMainComponent } from './acc-wid-main/acc-wid-main.component';
import { AccWidWebListPopupComponent } from './acc-wid-web-list-popup/acc-wid-web-list-popup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgSelectModule,
        Daterangepicker,
        LayoutModule,
        EditorModule,
        NgxDatatableModule,
        ComponentModule,
    ],
    declarations: [
        AccWidMainComponent,

        // AccWidCmnSendPopupComponent,
        AccWidInvocesListComponent,

        AccWidWebListPopupComponent,

        AccWidMainListComponent,
        AccWidInvLisItemComponent,
        AccWidInvLisItemCouponComponent,
    ],
    exports: [AccWidMainComponent, AccWidInvocesListComponent, AccWidMainListComponent],
    providers: [{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }],
})
export class AccWidgetsModule {}
